import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view";
import FieldString_RenderEditableInlineInput from "./inline-editable/input-editable-inline";

export default function FieldString_FormElementView(props:FieldFormElementViewProps) {

    const disabled  = _.get(props.options, 'disabled', false) || _.get(props, 'disabled', false)
    const value     = props.model[props.field.fieldId]

    // we need on change here to apply Min or MAX value
    const onChange = (value:any) => {
        value = props.field.normalizeValue(value)
        if (props.onChange) props.onChange(value)
    }

    return <FieldString_RenderEditableInlineInput viewClasses   = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", props.className)}
                                                  editClasses   = {Classes("ui5-txt-default ui5-field-form-editable h-36 p-l-10 p-r-10", props.className)}
                                                  field         = {props.field}
                                                  value         = {value}
                                                  options       = {props.options}
                                                  disabled      = {disabled}
                                                  onChange      = {onChange}
                                                  // onImmediateChange    = {props.onChange} - eto izmenyaetsya vo vremya redaktirovaniya
    />

}
